'use strict';

export default class RecoverPasswordController {
  /*@ngInject*/
  constructor($http, $q, $stateParams, $timeout) {
    this.$http = $http;
    this.$q = $q;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;

    this.showExpiredMsg = false;
    this.showForm = false;

    this.form = {};
    this.submitted = false;
    this.isSaving = false;
    this.errors;
    this.showThankYou = false;
  }

  getData() {
    let self = this;
    this.$http.get(`/api/users/recover/password/verifyToken/${this.$stateParams.token}`)
      .then(function(response) {
        if(response.data.status && response.data.status === 'expired') {
          self.showExpiredMsg = true;
          self.showForm = false;
          return;
        }
        self.showForm = true;
      }, function(err) {
        self.showExpiredMsg = true;
        self.showForm = false;
      });
  }

  submitForm(form) {
    if(form.$valid) {
      let self = this;
      this.submitted = true;
      this.isSaving = true;
      let payload = {
        newPassword: this.form.newPassword
      };
      this.$http.post(`/api/users/recover/password/new/${this.$stateParams.token}`, payload)
        .then(function(response) {
          self.showThankYou = true;
        }, function(err) {
          self.isSaving = false;
          // Update validity of form fields that match the mongoose errors
          self.errors = {};
          angular.forEach(err.data.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            self.errors[field] = error.message;
          });
        });
    }
  }

  $onInit() {
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./client/app/account/recover/recoverPassword.controller.js